module.exports = __webpack_public_path__ + "static/media/Kuva_6_6.e92d6e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_6_6.png
// module id = 1403
// module chunks = 0